/* eslint no-console: 0 */

import Vue from 'vue/dist/vue.esm'
import App from '../src/mags/index.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#vuejs_space',
    components: { App },
    render: function (createElement) {
      const props = JSON.parse(this.$el.dataset.props)
      return createElement('App',
      {
          props: props
      });
    }
  })
})
